/* eslint-disable @typescript-eslint/naming-convention */
export enum criticalMentionMessageTypesEnum {
    save = 'save',
    update = 'update',
    create = 'create'
}
